import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const ProjectForm = ({ project, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    status: 'active'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (project) {
      setFormData({
        name: project.name,
        status: project.status
      });
    }
  }, [project]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (project) {
        await api.put(`/projects/${project.id}`, formData);
      } else {
        await api.post('/projects', formData);
      }
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save project');
      setLoading(false);
    }
  };

  return (
    <div className="card" style={{ marginBottom: '20px' }}>
      <h3>{project ? 'Edit Project' : 'New Project'}</h3>
      <form onSubmit={handleSubmit}>
        {error && <div className="alert error">{error}</div>}
        
        <div className="form-group">
          <label>Project Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Status</label>
          <select
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="active">Active</option>
            <option value="completed">Completed</option>
            <option value="on_hold">On Hold</option>
          </select>
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <button type="submit" className="primary" disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </button>
          <button type="button" onClick={onClose} className="secondary">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProjectForm;